// components/Gallery/Gallery.js
import React, { useEffect, useState } from "react";
import "./gallery.css";
import axios from "axios";
import { Country, State, City } from "country-state-city";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const Gallery = () => {
  const [collections, setCollections] = useState([]);
  const [filteredCollections, setFilteredCollections] = useState([]);
  const [filter, setFilter] = useState("");

  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [filters, setFilters] = useState({
    category: null,
    subcategory: null,
    country: null,
    state: null,
    city: null,
  });

  const [filterOptions, setFilterOptions] = useState({
    categories: [],
    subcategories: [],
    countries: [],
    states: [],
    cities: [],
  });

  const API_URL = process.env.REACT_APP_API_URL;

  // Load collections + countries
  useEffect(() => {
    fetchCollections();

  const india = Country.getAllCountries().find((c) => c.isoCode === "IN");
    if (india) {
      setFilterOptions((prev) => ({
        ...prev,
        countries: [india],
      }));
    }
  }, []);

  const fetchCollections = async () => {
    try {
      const res = await axios.get(`${API_URL}/catagory`);
      const data = res.data.filter(
        (item) => item.category?.toLowerCase() === "gallary"
      );
      setCollections(data);
      setFilteredCollections(data);

      // Extract unique filter options
      const categories = [...new Set(data.map((v) => v.category).filter(Boolean))];
      const subcategories = [
        ...new Set(
          data.flatMap((v) =>
            Array.isArray(v.subcategory) ? v.subcategory : [v.subcategory]
          )
        ),
      ];

      setFilterOptions((prev) => ({
        ...prev,
        categories,
        subcategories,
      }));
    } catch (err) {
      console.error("Error fetching collections:", err);
    }
  };

  // update states when country changes
  useEffect(() => {
 

      // prioritize Tamil Nadu
      if (filters.country === "IN") {
        const allowedStates = ["KL", "TN", "KA"];
      let states = State.getStatesOfCountry("IN").filter((s) =>
        allowedStates.includes(s.isoCode)
      );

      setFilterOptions((prev) => ({ ...prev, states, cities: [] }));
      setFilters((prev) => ({ ...prev, state: null, city: null }));
    }
  }, [filters.country]);

  // update cities when state changes
  useEffect(() => {
    if (filters.country  === "IN" && filters.state) {
      const cities = City.getCitiesOfState(filters.country, filters.state).sort(
        (a, b) => a.name.localeCompare(b.name)
      );
      setFilterOptions((prev) => ({ ...prev, cities }));
      setFilters((prev) => ({ ...prev, city: null }));
    }
  }, [filters.state, filters.country]);

  // Apply filters + search
  useEffect(() => {
    let data = [...collections];

    if (filters.category) {
      data = data.filter((item) => item.category === filters.category);
    }
    if (filters.subcategory) {
      data = data.filter((item) =>
        Array.isArray(item.subcategory)
          ? item.subcategory.includes(filters.subcategory)
          : item.subcategory === filters.subcategory
      );
    }

    if (filters.city) {
      data = data.filter((v) =>
        v.location?.toLowerCase().includes(filters.city.toLowerCase())
      );
    } else if (filters.state) {
      const stateName = filterOptions.states.find(
        (s) => s.isoCode === filters.state
      )?.name;
      if (stateName) {
        data = data.filter((v) =>
          v.location?.toLowerCase().includes(stateName.toLowerCase())
        );
      }
    } else if (filters.country) {
      const countryName = filterOptions.countries.find(
        (c) => c.isoCode === filters.country
      )?.name;
      if (countryName) {
        data = data.filter((v) =>
          v.location?.toLowerCase().includes(countryName.toLowerCase())
        );
      }
    }

    if (filter.trim()) {
      const q = filter.toLowerCase();
      data = data.filter((item) => {
        const nameMatch = item.name?.toLowerCase().includes(q);
        const locationMatch = item.location?.toLowerCase().includes(q);
        const subcatMatch = Array.isArray(item.subcategory)
          ? item.subcategory.some((sub) => sub?.toLowerCase().includes(q))
          : item.subcategory?.toLowerCase().includes(q);
        return nameMatch || locationMatch || subcatMatch;
      });
    }

    setFilteredCollections(data);
  }, [filters, filter, collections, filterOptions]);

  const handleOpenModal = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

  return (
    <div className="gallery-page container mt-4">
      <h1 className="mt-5">Gallery</h1>

      {/* 🔹 Filters */}
      <div className="vendor-filters d-flex gap-3 mb-4 flex-wrap">
        {/* Country */}
        <select
          className="vendor-select"
          onChange={(e) =>
            setFilters({ ...filters, country: e.target.value || null })
          }
        >
          <option value="">Select Country</option>
          {filterOptions.countries.map((c) => (
            <option key={c.isoCode} value={c.isoCode}>
              {c.name}
            </option>
          ))}
        </select>

        {/* State */}
        <select
          className="vendor-select"
          onChange={(e) =>
            setFilters({ ...filters, state: e.target.value || null })
          }
          disabled={!filters.country}
        >
          <option value="">Select State</option>
          {filterOptions.states.map((s) => (
            <option key={s.isoCode} value={s.isoCode}>
              {s.name}
            </option>
          ))}
        </select>

        {/* City */}
        <select
          className="vendor-select"
          onChange={(e) =>
            setFilters({ ...filters, city: e.target.value || null })
          }
          disabled={!filters.state}
        >
          <option value="">Select City/District</option>
          {filterOptions.cities.map((city, i) => (
            <option key={i} value={city.name}>
              {city.name}
            </option>
          ))}
        </select>

        {/* Category */}
        <select
          className="vendor-select"
          onChange={(e) =>
            setFilters({ ...filters, category: e.target.value || null })
          }
        >
          <option value="">Select Category</option>
          {filterOptions.categories.map((cat, i) => (
            <option key={i} value={cat}>
              {cat}
            </option>
          ))}
        </select>

        {/* Subcategory */}
        <select
          className="vendor-select"
          onChange={(e) =>
            setFilters({ ...filters, subcategory: e.target.value || null })
          }
        >
          <option value="">Select Subcategory</option>
          {filterOptions.subcategories.map((sub, i) => (
            <option key={i} value={sub}>
              {sub}
            </option>
          ))}
        </select>
      </div>

      

      {/* 🔹 Gallery Cards */}
      <div className="row">
        {filteredCollections.length > 0 ? (
          filteredCollections.map((item) => (
            <div className="col-md-4 mb-4" key={item._id}>
              <div className="card h-100">
                {item.image && (
                  <img
                    src={`${API_URL}/${item.image}`}
                    alt={item.name}
                    className="card-img-top"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                )}
                <div className="card-body">
                  <h5 className="card-title">{item.subcategory || "N/A"}</h5>
                  <p>{item.description || "N/A"}</p>
                  <button
                    className="btn btn-primary"
                    onClick={() => handleOpenModal(item)}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No gallery items found.</p>
        )}
      </div>

      {/* 🔹 Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          {selectedItem ? (
            <div className="d-flex gap-3">
              <div>
                {selectedItem.image && (
                  <img
                    src={`${API_URL}/${selectedItem.image}`}
                    alt={selectedItem.name}
                    className="img-fluid rounded"
                    style={{ maxWidth: "300px" }}
                  />
                )}
              </div>
              <div>
                <h3>{selectedItem.subcategory || "Gallery Item"}</h3>
                <p>{selectedItem.description}</p>
                <Button variant="outline-danger">Send Enquiry</Button>
              </div>
            </div>
          ) : (
            <p>Loading...</p>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Gallery;
